enum Mode {
    Global = 'Global',
    Local = 'Local'
}

export default Mode;
